import { render, staticRenderFns } from "./businessCate.vue?vue&type=template&id=4df282c7&scoped=true&"
import script from "./businessCate.vue?vue&type=script&lang=js&"
export * from "./businessCate.vue?vue&type=script&lang=js&"
import style0 from "./businessCate.vue?vue&type=style&index=0&id=4df282c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df282c7",
  null
  
)

export default component.exports